import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'
import { isEmpty } from '../../../utils/isEmpty'

const PARTNER_ENDPOINTS: { [key: string]: string } = {
  PUBLISHER: '/api/publishers',
  AFFILIATE: '/api/affiliates'
}

const urlBuilder = (id: string, type: string) => {
  return `${PARTNER_ENDPOINTS[type]}/${id}`
}

export const getPartnerResources = async () => {
  const { get } = StackAPI()

  const partner = Storage().getActiveRole()

  if (isEmpty(partner)) return { error: 'no partner' }

  const { id, type } = partner

  const path = urlBuilder(id, type)

  return get({ path })
    .then((response) => {
      if (response.status !== 200) {
        throw new Error('bad response')
      }

      return response.data
    })
    .catch((error) => {
      throw error
    })
}
